import React, { Component } from 'react';
import { useLocation } from "react-router-dom";
import * as Dapp from "@elrondnetwork/dapp";
import { Link } from "react-router-dom";

const WalletOptions = () => {
    const webWalletLogin = Dapp.useWebWalletLogin({callbackRoute: "/"});
    const webExtensionLogin = Dapp.useExtensionLogin({callbackRoute: "/"});

    const {storage} = Dapp.useContext();

    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const { type } = Object.fromEntries(query);

    switch (type) {
        case "ledger":
            return <Dapp.Pages.Ledger callbackRoute="/" />;
        case "maiar":
            return <Dapp.Pages.WalletConnect
                callbackRoute="/"
                logoutRoute="/"
                title="Maiar Login"
                lead="Scan the QR code using Maiar"
            />;
        default:
            return <div className="row justify-content-center items">
            {/* Maiar App */}
            <div className="col-12 col-md-6 col-lg-3 item">
                <div className="card single-wallet">
                    <Link className="d-block text-center" to="/wallet-connect?type=maiar">
                        <img className="avatar-lg" src="/img/maiar-32x32.png" alt="" />
                        <h4 className="mb-0">Maiar</h4>
                        <p>Connect using the Maiar Mobile Application</p>
                    </Link>
                </div>
            </div>
            {/* Maiar Extension */}
            <div className="col-12 col-md-6 col-lg-3 item d-none">
                <div className="card single-wallet">
                    <Link className="d-block text-center" to="#" onClick={() => webExtensionLogin()}>
                        <img className="avatar-lg" src="/img/maiar-32x32.png" alt="" />
                        <h4 className="mb-0">Extension</h4>
                        <p>Connect using Maiar Wallet Browser Extension</p>
                    </Link>
                </div>
            </div>
            {/* Ledger */}
            <div className="col-12 col-md-6 col-lg-3 item d-none">
                <div className="card single-wallet">
                    <Link className="d-block text-center" to="/wallet-connect?type=ledger">
                        <img className="avatar-lg" src="/img/ledger-logo.png" alt="" />
                        <h4 className="mb-0">Ledger</h4>
                        <p>Connect your Ledger Wallet through the Ledger application</p>
                    </Link>
                </div>
            </div>
            {/* Web wallet */}
            <div className="col-12 col-md-6 col-lg-3 item d-none">
                <div className="card single-wallet">
                    <Link className="d-block text-center" to="#" onClick={() => webWalletLogin()}>
                        <img className="avatar-lg" src="/img/maiar-32x32.png" alt="" />
                        <h4 className="mb-0">Web Wallet</h4>
                        <p>Connect using the official Elrond Web Wallet</p>
                    </Link>
                </div>
            </div>
        </div>
            // return <Dapp.Pages.Unlock
            //     callbackRoute={routeNames.home}
            //     logoutRoute={routeNames.home}
            //     title=""
            //     lead=""
            //     ledgerRoute="/connect?type=ledger"
            //     walletConnectRoute="/connect?type=maiar"
            // />;
    }
};

export default WalletOptions;